import { render, staticRenderFns } from "./ReportsHeader.vue?vue&type=template&id=2f062d42&lang=pug&"
import script from "./ReportsHeader.vue?vue&type=script&lang=js&"
export * from "./ReportsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports